import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDateID, waLink } from "@/lib/constants";
import { StatusBadge } from "@/components/Badges";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Flower, WhatsappLogo } from "@phosphor-icons/react";

const GROUPS = [
  { key: "Prenatal Yoga Pemula", label: "Pemula" },
  { key: "Prenatal Yoga Reguler", label: "Reguler" },
  { key: "Prenatal Yoga >34 Minggu", label: ">34 Minggu" },
];

export default function PrenatalYoga() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/reservations", { params: { kategori: "yoga" } }).then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, []);

  const byGroup = (key) => items.filter((i) => i.jenis_layanan === key);

  return (
    <div className="animate-fade-up space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <Flower size={26} weight="duotone" className="text-purple-500" />
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-800">Prenatal Yoga</h1>
        </div>
        <p className="mt-1 text-sm text-slate-500">Peserta kelas prenatal yoga</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-purple-200 border-t-purple-500" />
        </div>
      ) : (
        <Tabs defaultValue="Prenatal Yoga Pemula">
          <TabsList className="w-full justify-start gap-2 rounded-xl bg-purple-50 p-1">
            {GROUPS.map((g) => (
              <TabsTrigger
                key={g.key}
                value={g.key}
                data-testid={`yoga-tab-${g.label}`}
                className="rounded-lg data-[state=active]:bg-white data-[state=active]:text-purple-700 data-[state=active]:shadow-sm"
              >
                {g.label} ({byGroup(g.key).length})
              </TabsTrigger>
            ))}
          </TabsList>

          {GROUPS.map((g) => (
            <TabsContent key={g.key} value={g.key} className="mt-5">
              {byGroup(g.key).length === 0 ? (
                <div className="rounded-2xl border border-dashed border-purple-200 bg-white/50 p-12 text-center text-sm text-slate-500">
                  Belum ada peserta di kelas {g.label}.
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  {byGroup(g.key).map((r) => (
                    <div key={r.id} data-testid={`yoga-card-${r.id}`} className="rounded-2xl border border-purple-100 bg-white p-5 shadow-sm">
                      <div className="flex items-start justify-between gap-2">
                        <p className="font-heading text-lg font-bold text-slate-800">{r.nama_lengkap}</p>
                        <StatusBadge status={r.status} />
                      </div>
                      <div className="mt-3 grid grid-cols-2 gap-3 text-sm">
                        <Info label="Usia" value={r.usia ? `${r.usia} th` : "-"} />
                        <Info label="Usia Kehamilan" value={r.usia_kehamilan_minggu ? `${r.usia_kehamilan_minggu} mgg` : "-"} />
                        <Info label="Kehamilan ke-" value={r.kehamilan_ke ?? "-"} />
                        <Info label="Tanggal Kelas" value={formatDateID(r.tanggal_kunjungan)} />
                        <Info label="No. WhatsApp" value={r.no_whatsapp} />
                        <Info label="Jam" value={r.jam_kunjungan} />
                      </div>
                      {r.keluhan ? (
                        <p className="mt-3 rounded-lg bg-purple-50 px-3 py-2 text-sm text-slate-600">
                          <span className="font-semibold text-purple-700">Catatan:</span> {r.keluhan}
                        </p>
                      ) : null}
                      <a
                        href={waLink(r.no_whatsapp, `Halo ${r.nama_lengkap}, terkait kelas Prenatal Yoga Anda di GBS Clinic.`)}
                        target="_blank"
                        rel="noreferrer"
                        className="mt-3 inline-flex items-center gap-2 rounded-xl bg-[#25D366] px-4 py-2 text-sm font-bold text-white transition-transform active:scale-95"
                      >
                        <WhatsappLogo size={18} weight="fill" /> Hubungi
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </TabsContent>
          ))}
        </Tabs>
      )}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-xs text-slate-400">{label}</p>
      <p className="font-semibold text-slate-700">{value}</p>
    </div>
  );
}
